import logobar from 'components/logobar'
import LogoSketch from 'abstractions/logobar-sketch'

// Import whatever framework you're confortable with

class Sketch extends LogoSketch {
  constructor (el) {
    super(el)

    this.title = 'sketchExample'
    this.colors = [
      '#D4C9C9',
      '#FFCCFE',
      '#5B9CDA',
      '#FF813D',
      '#5CD077'
    ]
    this.svg = this.element.querySelector('.logobar__big svg')
    console.log(this.title, this.element)
  }

  changeColor () {
    const color = this.colors[Math.floor(Math.random() * this.colors.length)]
    this.svg.style.fill = color
  }

  // This is called just before logobar starts opening
  willStart () {
    this.bindFuncs(['changeColor'])
    console.log(this.title, 'will start')
  }

  // this is called just after logobar has been opened
  didStart () {
    this.changeColor()
    this.timer = setInterval(this.changeColor, 500)
    console.log(this.title, 'has started')
  }

  // This is called just before logobar starts closing
  willClose () {
    clearInterval(this.timer)
    console.log(this.title, 'will be terminated')
  }

  // This is called just after logobar has been closed
  didClose () {
    this.svg.style.fill = null
    console.log(this.title, 'has been terminated')
  }
}

logobar.registerSketch(Sketch)
